export default __webpack_public_path__ + "static/media/skyniche-logo-green.f35c4d13.png";